(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSections(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function setButtonState(btn, state) {
    if (!btn) return;
    var textEl = btn.querySelector('.card__qa-text');
    if (!btn.dataset.originalText && textEl) {
      btn.dataset.originalText = textEl.textContent.trim();
    }
    if (state === 'loading') {
      btn.dataset.qaState = 'loading';
      btn.disabled = true;
    } else {
      delete btn.dataset.qaState;
      btn.disabled = false;
      if (textEl) textEl.textContent = btn.dataset.originalText;
    }
  }

  function closeAllOtherPanels(currentRoot) {
    document.querySelectorAll('[data-variant-panel]:not([hidden])').forEach(function (panel) {
      var otherRoot = panel.closest('[data-product-card-root]');
      if (otherRoot && otherRoot !== currentRoot) collapsePanel(otherRoot);
    });
  }

  function expandPanel(root) {
    closeAllOtherPanels(root);
    var panel = root.querySelector('[data-variant-panel]');
    if (!panel) return;
    var footer = panel.closest('.card__footer');
    panel.hidden = false;
    if (footer) footer.classList.add('card__footer--open');
    var track = panel.querySelector('[data-variant-track]');
    if (track) initDragScroll(track);
  }

  function collapsePanel(root) {
    var panel = root.querySelector('[data-variant-panel]');
    if (!panel || panel.hidden) return;
    var footer = panel.closest('.card__footer');
    panel.classList.add('card__variant-panel--closing');
    panel.addEventListener('animationend', function () {
      panel.classList.remove('card__variant-panel--closing');
      panel.hidden = true;
      if (footer) footer.classList.remove('card__footer--open');
    }, { once: true });
  }

  function pushAddToCartEvent(data) {
    if (!data) return;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: currency,
        value: (data.price || 0) / 100,
        items: [{
          item_id: data.sku || String(data.variant_id || data.id || ''),
          item_name: data.product_title || data.title || '',
          item_brand: data.vendor || '',
          price: (data.price || 0) / 100,
          quantity: data.quantity || 1
        }]
      }
    });
  }

  function addToCart(variantId, btn) {
    var cartDrawer = getCartDrawer();
    setButtonState(btn, 'loading');

    var cartAddUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: getSections(cartDrawer) })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (data) {
        setButtonState(btn, 'normal');
        pushAddToCartEvent(data);
        var root = btn.closest('[data-product-card-root]');
        if (root) collapsePanel(root);
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          }
        }
      })
      .catch(function () {
        setButtonState(btn, 'normal');
      });
  }

  function initDragScroll(track) {
    if (!track || track.dataset.dragInit) return;
    track.dataset.dragInit = '1';

    var active = false;
    var lastX = 0;
    var startX = 0;
    var didDrag = false;
    var DRAG_THRESHOLD = 5;

    function onDown(x) {
      active = true;
      lastX = x;
      startX = x;
      didDrag = false;
      track.dataset.dragging = '1';
    }

    function onMove(x) {
      if (!active) return;
      if (Math.abs(x - startX) > DRAG_THRESHOLD) didDrag = true;
      track.scrollLeft += lastX - x;
      lastX = x;
    }

    function onUp() {
      active = false;
      delete track.dataset.dragging;
    }

    track.addEventListener('mousedown', function (e) { onDown(e.clientX); e.preventDefault(); });
    track.addEventListener('touchstart', function (e) { onDown(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('mousemove', function (e) { onMove(e.clientX); });
    track.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('mouseup', onUp);
    track.addEventListener('mouseleave', onUp);
    track.addEventListener('touchend', onUp, { passive: true });

    track.addEventListener('click', function (e) {
      if (didDrag) {
        e.stopPropagation();
        e.preventDefault();
        didDrag = false;
      }
    }, true);
  }

  function onClick(e) {
    var root = e.target.closest('[data-product-card-root]');
    if (!root) return;

    if (e.target.closest('[data-variant-open]')) {
      e.preventDefault();
      expandPanel(root);
      return;
    }

    if (e.target.closest('[data-variant-close]')) {
      e.preventDefault();
      collapsePanel(root);
      return;
    }

    var addBtn = e.target.closest('[data-quick-add-variant]');
    if (addBtn && !addBtn.disabled && addBtn.dataset.qaState !== 'loading') {
      e.preventDefault();
      addToCart(addBtn.dataset.quickAddVariant, addBtn);
    }
  }

  function init() {
    if (window.__tlabQAClick) document.removeEventListener('click', window.__tlabQAClick);
    window.__tlabQAClick = onClick;
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
